import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("定時拍照")
const _hoisted_2 = { class: "mb-3 form-check form-switch" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "switch"
}, "開啟定時拍照", -1)
const _hoisted_5 = { class: "d-flex flex-wrap" }
const _hoisted_6 = ["id", "value", "checked", "disabled"]
const _hoisted_7 = ["for"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " 取消 ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "送出", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    confirmHandler: _ctx.confirmHandler,
    onOpen: _ctx.openHandler
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          role: "switch",
          id: "switch",
          checked: _ctx.timer,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChangeTimer && _ctx.handleChangeTimer(...args)))
        }, null, 40, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intervals, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "form-check me-2",
            key: i
          }, [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              name: "time-interval",
              id: `radio${i}`,
              value: i,
              checked: _ctx.interval === i,
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChangeInterval && _ctx.handleChangeInterval(...args))),
              disabled: !_ctx.timer
            }, null, 40, _hoisted_6),
            _createElementVNode("label", {
              class: "form-check-label",
              for: `radio${i}`
            }, _toDisplayString(i) + " 分鐘 ", 9, _hoisted_7)
          ]))
        }), 128))
      ])
    ]),
    footer: _withCtx(() => [
      _hoisted_8,
      _hoisted_9
    ]),
    _: 1
  }, 8, ["confirmHandler", "onOpen"]))
}